import React, { useEffect, useState, useCallback, useRef } from 'react';
import { createRoot } from 'react-dom/client';
import { Message } from '@ok/okd';
import CurrencyInfoContext from './context';
import { MediaQuery } from '@ok/okg';
import { getCurCurrencyByUrl, currencyInfoStorage } from './common/util';
import { PAGE_PATH } from './common/context';
import URL from './common/URL';

import Sm from './layout/Sm';
import Md from './layout/Md';

import './index.less';

const { utils: { ont } = {} } = window;
const catchCurrencyList = currencyInfoStorage.get('currencyList');
const curCurrency = getCurCurrencyByUrl(catchCurrencyList);

const App = () => {
  const [currency, setCurrency] = useState(curCurrency);
  const currencyList = useRef(catchCurrencyList);
  const [currencyInfo, setCurrencyInfo] = useState({});
  const [loading, setLoading] = useState(true);

  const getCurrencyDetail = useCallback(
    async (currency, showLoading = false) => {
      setLoading(showLoading);
      try {
        const { id, symbol } = currency;
        history.replaceState(
          null,
          '',
          `${PAGE_PATH.CURRENCY_INFO}${symbol.toLowerCase()}`
        );
        const {
          data: { data: info },
        } = await ont.get(`${URL.GET_CURRENCY_DETAIL}?currencyId=${id}`);
        setCurrencyInfo(info);
        setCurrency(currency);
        setLoading(false);
      } catch (err) {
        setLoading(false);
        setCurrencyInfo({});
        Message.error(err?.msg || '');
      }
    },
    []
  );

  const getCurrencyList = async () => {
    setLoading(true);
    try {
      const {
        data: { data: list },
      } = await ont.get(URL.GET_CURRENCY_LIST);
      const curCurrency = getCurCurrencyByUrl(list);
      currencyList.current = list;
      currencyInfoStorage.set('currencyList', list);
      getCurrencyDetail(curCurrency, true);
    } catch (err) {
      setLoading(false);
      currencyList.current = [];
      Message.error(err?.msg || '');
    }
  };

  useEffect(() => {
    getCurrencyList();
  }, []);

  return (
    <div className="currency-info-box">
      <CurrencyInfoContext.Provider
        value={{
          loading,
          currency,
          currencyInfo,
          getCurrencyDetail,
          currencyList: currencyList.current,
        }}
      >
        <div className="main-box">
          <MediaQuery sm={<Sm />} md={<Md />} />
        </div>
      </CurrencyInfoContext.Provider>
    </div>
  );
};

const root = createRoot(document.getElementById('root'));
root.render(<App />);
